if (typeof DigiTickets !== 'object') {
    DigiTickets = {};
}

DigiTickets.Worldpay = {};
